import {QueryCommand} from "xmgoing-server";
import GoingUtils from "@/utils/goingUtils";

/**
 * 查询用户根据拼音输入
 * @param value
 * @param backFun
 * @constructor
 */
export function QueryAccountByPinyin(value:string,backFun,showLoading=true){
  showLoading?GoingUtils.showLoading():'';
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/account/read_all_casecade`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params: {name: unref(value)}, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询所有租户
 * @param value
 * @param backFun
 * @param showLoading
 * @constructor
 */
export function QueryAllAccount(value:string,backFun,showLoading=true){
  showLoading?GoingUtils.showLoading():'';
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/account/read_all`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params: {name: unref(value)}, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 查询用户集合 根据 用户id集合
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryAccountByIds(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/account/listTenantByIds`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 查询用户 根据机构id
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryUsersByOrgId(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/users/getUserByOrgId/`+params.orgId,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 查询角色列表
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryRoles(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/roles/getAllRoleByBelong/unit`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询用户根据角色id
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryUsersByRoleId(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/component/getUserByRoleId/`+params.roleId,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}
